/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Feature_LinkInputs */

const en_mk_feature_link = /** @type {(inputs: Mk_Feature_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Learn more`)
};

const id_mk_feature_link = /** @type {(inputs: Mk_Feature_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pelajari lebih lanjut`)
};

/**
* | output |
* | --- |
* | "Learn more" |
*
* @param {Mk_Feature_LinkInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_feature_link = /** @type {((inputs?: Mk_Feature_LinkInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Feature_LinkInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_feature_link(inputs)
	return en_mk_feature_link(inputs)
});